import React from "react";
import PropTypes from "prop-types";

import {
  // CardTitle,
  Card,
  CardImg,
  CardBody
} from "../../../../../components/simple";

import styles from "./audience-portrait.module.scss";

const AudiencePortrait = ({ audience }) => {
  const { imageLink = "" } = audience;

  return (
    <div>
      <Card className={styles["audience-portrait-container"]}>
        <CardImg
          className={styles["audience-portrait-image"]}
          top
          width="100%"
          src={imageLink}
          alt="Card image cap"
        />
        <CardBody className={styles["audience-portrait-body"]}></CardBody>
      </Card>
    </div>
  );
};

AudiencePortrait.propTypes = {
  audience: PropTypes.shape({
    imageLink: PropTypes.string,
    text: PropTypes.string
  }).isRequired
};

export default AudiencePortrait;
